import {createSlice} from "@reduxjs/toolkit";
import {IAppointmentRedux} from "../../interfaces";

export const reducerName = "appointment";
export const initialState: IAppointmentRedux = {
    appointment: {
        id: 0,
        animal: null,
        chatId: "",
        clientUserId: 0,
        created: "",
        description: "",
        finished: false,
        promotion: "",
        scheduledDate: "",
        status: "REQUEST_MADE",
        type: "ADVICE_CHAT",
        vetUserId: 0,
    },
    prescriptions: [],
    notes: [],
    review: {
        appointmentId: "",
        stars: "",
        comments: "",
        requestsPrescription: false,
        type: "",
    },
};

const appointmentReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setAppointment: (state, action) => ({
            ...state,
            appointment: action.payload
        }),
        setReview: (state, action) => ({
            ...state,
            review: action.payload
        }),
        setNotes: (state, action) => ({
            ...state,
            notes: action.payload
        }),
        setPrescriptions: (state, action) => ({
            ...state,
            prescriptions: action.payload
        }),
        deletePrescription: (state, action) => {
            let list = [...state.prescriptions];
            let itemToDelete;
            if(action.payload.id) {
                itemToDelete = state.prescriptions.find(item => item.id === action.payload.id);
            } else {
                itemToDelete = state.prescriptions.find(item => item.name === action.payload.name);
            }
            list.splice(list.indexOf(itemToDelete), 1);
            return {
                ...state,
                prescriptions: [...list]
            };
        },
    }
});

export default appointmentReducer.reducer;
export const {
    setAppointment,
    setReview,
    setNotes,
    setPrescriptions,
    deletePrescription
} = appointmentReducer.actions;
